import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

export interface MeetListItem {
  id: number;
  calendar_id: number;
  candidate_id: number;
  candidate_firstname?: string | null;
  candidate_lastname?: string | null;
  candidate_email?: string | null;
  candidate_phone?: string | null;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  meeting_url?: string | null;
  created_at?: string | null;
  /** "itw1" (agenda recruteur) | "itw2" (agenda intervieweur). Deduit de l'axe
   *  de propriete du calendrier — `meets` ne porte pas de colonne `stage`. */
  stage?: string | null;
  /** L'evenement a bien ete pousse dans l'agenda Google/Microsoft/CalDAV.
   *  Preuve directe qu'un entretien confirme apparait dans l'agenda. */
  external_event_synced?: boolean;
  organization_id?: number | null;
}

export interface MeetsSummary {
  total: number;
  with_external_event: number;
  itw1: number;
  itw2: number;
}

export interface PaginatedMeetsResponse {
  items: MeetListItem[];
  total: number;
  page: number;
  size: number;
  pages: number;
  summary: MeetsSummary;
}

export interface MeetsFilters {
  page?: number;
  size?: number;
  /** Bornes INCLUSIVES sur la date de reservation (YYYY-MM-DD). */
  created_from?: string;
  created_to?: string;
  stage?: "itw1" | "itw2";
}

export async function listMeets(navigate: NavigateFunction, params?: MeetsFilters) {
  const q = new URLSearchParams();
  q.set("page", String(params?.page ?? 1));
  q.set("size", String(params?.size ?? 50));
  if (params?.created_from) q.set("created_from", params.created_from);
  if (params?.created_to) q.set("created_to", params.created_to);
  if (params?.stage) q.set("stage", params.stage);
  const url = `${API_URL}/meets?${q.toString()}`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du chargement des rendez-vous");
  return res.json() as Promise<PaginatedMeetsResponse>;
}
